
































































import { isMobile, isTablet } from "@zoovu/design-system/src/helpers";

import { Component, InjectComponent, Prop, Question, Vue, VueComponent } from "@zoovu/runner-browser-api";
import { QuestionHeadView } from "@zoovu/runner-web-design-base";
import { sanitize } from "dompurify";
import { vTooltip } from "@zoovu/design-system/src/plugins";
import { MobileInfoTextTrigger, TooltipConfiguration, whitelistedAttributes } from "../types";

@Component({
  name: "QuestionHeadView",
  mixins: [QuestionHeadView],
  directives: {
    tooltip: vTooltip.directives.tooltip,
  },
})
export default class QuestionHeadViewExtended extends Vue {
  @Prop()
  question!: Question;

  @InjectComponent("Modal")
  modal: VueComponent;

  @InjectComponent("InfoTextMobile")
  InfoTextMobile: VueComponent;

  isMobile: boolean = isMobile();

  isTablet: boolean = isTablet();

  infoTextShown = false;

  get tooltipEnabled(): boolean {
    return !this.isMobile && !this.isTablet;
  }

  clickOnInfoText(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    if (!this.isMobile && !this.isTablet) return;
    this.showInfoText();
  }

  get mobileInfoTextTrigger(): MobileInfoTextTrigger {
    return this.isMobile ? { click: this.showInfoText } : {};
  }

  get infoTextTooltipConfiguration(): TooltipConfiguration {
    return {
      autoHide: false,
      content: sanitize(this.question.infoText, { ADD_ATTR: whitelistedAttributes }),
      container: this.containerDivId,
      delay: {
        show: 0,
        hide: 2000,
      },
    };
  }

  hideInfoText(): void {
    this.infoTextShown = false;
  }

  showInfoText(): void {
    this.infoTextShown = true;
  }

  get containerDivId(): string {
    return `#${this.$root.containerDivId} > div`;
  }
}
